import {
  BottomSheet,
  BottomSheetIllustrationContent,
  type UseModalState,
} from "@clipboard-health/ui-components";
import { openZendeskMessaging } from "@src/appV2/lib/ZendeskMessaging/openZendeskMessaging";
import { BottomSheetHeader } from "@src/appV2/redesign/components/BottomSheetHeader";
import { Button } from "@src/appV2/redesign/components/Button";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";

import { TextButton } from "../../components/TextButton";

interface WorkBadgeOrderFailureBottomSheetProps {
  modalState: UseModalState;
  onRetry: () => void;
}

export function WorkBadgeOrderFailureBottomSheet(props: WorkBadgeOrderFailureBottomSheetProps) {
  const { modalState, onRetry } = props;

  return (
    <BottomSheet
      modalState={modalState}
      header={<BottomSheetHeader onClose={modalState.closeModal} />}
      footer={
        <DialogFooter orientation="vertical">
          <Button fullWidth variant="contained" size="large" onClick={onRetry}>
            Try again
          </Button>
          <TextButton
            size="large"
            sx={{ marginTop: 1, marginBottom: 3 }}
            onClick={() => {
              modalState.closeModal();
              void openZendeskMessaging();
            }}
          >
            Contact Clipboard Support
          </TextButton>
        </DialogFooter>
      }
    >
      <BottomSheetIllustrationContent
        illustrationType="warning"
        title="Order could not be placed"
        description="Something went wrong while placing your badge order. Try again or reach out to Clipboard Support."
      />
    </BottomSheet>
  );
}
